import React, { createContext, useContext, useState, useEffect } from "react";

const ContentContext = createContext();

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetch('/data/content.json')
      .then((response) => response.json())
      .then((data) => setContent(data))
      .catch((error) => console.error('Error loading JSON:', error));
  }, []);

  if (!content) {
    return <div></div>; // Show a loader while fetching data
  }

  return (
    <ContentContext.Provider value={content}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => {
  return useContext(ContentContext);
};
